import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
      title={isDark ? t('theme.lightMode') : t('theme.darkMode')}
      className={`inline-flex items-center gap-2 rounded-lg border border-zinc-300 bg-zinc-100 px-3 py-1.5 text-sm text-zinc-700 transition hover:bg-zinc-200 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-200 dark:hover:bg-zinc-700 ${className}`}
    >
      <span aria-hidden className="text-base leading-none">
        {isDark ? '☀️' : '🌙'}
      </span>
      <span className="hidden sm:inline">{isDark ? t('theme.light') : t('theme.dark')}</span>
    </button>
  );
};

export default ThemeToggle;
